(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const consent = form?.querySelector('[data-newsletter-consent]');
    const params = new URLSearchParams(location.search);
    const status = root.querySelector('[data-newsletter-status]');
    const feedback = root.querySelector('[data-newsletter-unconfirmed]');
    const preview = window.Shopify?.theme?.role !== 'main';
    root.querySelectorAll('[data-newsletter-language]').forEach((link) => {
      if (preview && params.get('view') === 'nass-newsletter') {
        const visitorPreview = location.hostname.endsWith('.shopifypreview.com');
        const portuguese = link.dataset.newsletterLanguage === 'pt-PT';
        const path = portuguese ? (visitorPreview ? '/pt-pt' : '/pt') : '/';
        const target = new URL(path, location.origin);
        target.searchParams.set('view', 'nass-newsletter');
        if (!visitorPreview && window.Shopify?.theme?.id) target.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        link.href = target.pathname + target.search;
      } else if (preview && window.Shopify?.theme?.id) {
        const target = new URL(link.getAttribute('href'), location.origin);
        target.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        target.searchParams.set('pb', '0');
        link.href = target.pathname + target.search;
      }
    });
    if (!status && params.get('form_type') === 'customer' && feedback) {
      feedback.hidden = false;
      feedback.focus({ preventScroll: true });
    } else if (status && params.get('customer_posted') === 'true') {
      status.focus({ preventScroll: true });
    }
    const canTrack = () => {
      try {
        const privacy = window.Shopify?.customerPrivacy;
        return !preview && privacy?.currentVisitorConsent?.().analytics === 'yes' && privacy.analyticsProcessingAllowed?.() === true;
      } catch { return false; }
    };
    const trackAttempt = () => {
      if (!canTrack() || typeof window.gtag !== 'function') return;
      try {
        window.gtag('event', 'nass_newsletter_submit', {
          send_to: 'G-5PJ884HBZ6',
          form_id: 'nass_newsletter_landing',
          language: root.dataset.locale,
          page_location: location.origin + location.pathname,
          page_referrer: '',
          transport_type: 'beacon'
        });
      } catch {}
    };
    let submitting = false;
    const reset = () => { submitting = false; form?.removeAttribute('aria-busy'); };
    form?.addEventListener('submit', (event) => {
      if (preview || !consent?.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!preview) consent?.reportValidity();
        return;
      }
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.reportValidity();
        return;
      }
      if (submitting) return;
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      trackAttempt();
      window.setTimeout(reset, 12000);
    }, true);
    window.addEventListener('pageshow', reset);
  };
  const initializeAll = () => document.querySelectorAll('[data-nass-newsletter]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();


